import { Component, computed, inject, input } from '@angular/core';

import { FileService } from '@evc/platform';
import {
  IconComponent,
  StatusIndicatorComponent,
  TooltipHoverDirective,
} from '@evc/web-components';
import { TranslatePipe } from '@shared/services/i18n/i18n.module';

import { FileItem } from '@app/types/file-item.type';

@Component({
  selector: 'drive-file-item',
  templateUrl: './file-item.component.html',
  styleUrl: './file-item.component.scss',
  imports: [
    IconComponent,
    StatusIndicatorComponent,
    TooltipHoverDirective,
    TranslatePipe,
  ],
})
export class FileItemComponent {
  #fileService = inject(FileService);

  file = input.required<FileItem>();
  /** lg for title (right pannel) */
  size = input<'sm' | 'lg'>('sm');

  icon = computed<string>(() => this.#fileService.getFileIcon(this.file()));
}
